export default __webpack_public_path__ + "static/media/banner-video.1c6e7753.mp4";